export const getMergedAssets = (imageAssets = [], videoAssets = []) => {
    const mergedAssets = [...imageAssets];
    const sortedVideoAssets = (videoAssets ?? []).sort((a, b) => (a.position ?? 0) - (b.position ?? 0));
    for (const videoAsset of sortedVideoAssets) {
        const { position = mergedAssets.length } = videoAsset;
        const insertPosition = Math.min(position, mergedAssets.length);
        mergedAssets.splice(insertPosition, 0, videoAsset);
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    return mergedAssets.map(({ position, ...rest }) => rest);
};
//# sourceMappingURL=getMergedAssets.js.map